<template>
    <div class="myskov">
        <div class="myskov__header">
            <div class="myskov__header__content">
                <h1 v-text="translations.title"></h1>
                <img img src="./../../img/my-skov-rejser/myskov-plane.svg" alt="">
            </div>
        </div>
        <div class="myskov__content">
            <myskov-menu :is-logged-in="isLoggedIn"></myskov-menu>
            <div class="my-skov-area">
                <!-- Shown when not logged in -->
                <login-box v-if="isLoginPage"></login-box>
                <!-- Shown on login -->
                <myskov-area v-if="!isLoginPage"></myskov-area>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginBox from '../components/myskov/login-area.vue';
    import MyskovArea from '../components/myskov/myskov-area.vue';
    import MyskovMenu from '../components/myskov/myskov-menu.vue';

    export default {
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.MYSKOV_PAGE
            }
        },
        watch: {
            '$route.params.page'() {
                this.checkPage();
            },
            'isLoggedIn'() {
                this.checkLogin();
            }
        },
        mounted() {
            this.checkPage();
        },
        computed: {
            isLoginPage() {
                return ['forgotpw', 'new-user', 'login'].indexOf(this.$route.params.page) > -1 ? true : false;
            },
            allowedToVisit() {
                return this.isLoginPage || ['offers'].indexOf(this.$route.params.page) > -1;
            },
            isLoggedIn() {
                return this.$store.getters.isLoggedIn;
            }
        },
        methods: {
            checkLogin() {
                if(!this.isLoggedIn && !this.allowedToVisit) {
                    this.$router.push({
                        path: '/myskov/login'
                    });
                }
            },
            checkPage() {
                this.checkLogin(); //Enable for automatic redirect to login pages
            }
        },
        components: {
            LoginBox,
            MyskovArea,
            MyskovMenu
        }
    }
</script>
